import { Box, Skeleton, useTheme } from "@outschool/backpack";
import React from "react";

export const SkeletonCard = () => {
  return (
    <Box
      sx={{
        borderRadius: "8px",
        backgroundColor: "#FFF",
        minHeight: "180px",
        padding: "8px",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        border: "1px solid",
        borderColor: "neutral.50",
        boxShadow:
          "0 1px 4px 0 rgba(0, 0, 0, 0.04), 0 0 8px 0 rgba(0, 0, 0, 0.04)",
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
        overflowWrap: "break-word",
        wordBreak: "break-word",
      }}
      data-test-id="mobile-search-listing-skeleton"
    >
      {/* Row 1: Image, Title/Price, Heart */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        {/* Image skeleton */}
        <Skeleton
          variant="rectangular"
          width={80}
          height={60}
          sx={{ borderRadius: "8px", flexShrink: 0 }}
        />

        {/* Title and price skeleton */}
        <Box
          sx={{ flex: 1, display: "flex", flexDirection: "column", gap: "4px" }}
        >
          <Skeleton variant="text" width="90%" height={20} />
          <Skeleton variant="text" width="40%" height={16} />
        </Box>

        {/* Heart button skeleton */}
        <Skeleton variant="circular" width={24} height={24} />
      </Box>

      {/* Row 2: Teacher name and rating */}
      <Box sx={{ paddingBottom: "4px" }}>
        <Skeleton variant="text" width="60%" height={16} />
        <Skeleton variant="text" width="50%" height={14} />
      </Box>

      {/* Row 3: Attribute chips and next session */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {/* Attribute chips row */}
        <Box sx={{ display: "flex", gap: "8px" }}>
          <Skeleton
            variant="rectangular"
            width={60}
            height={24}
            sx={{ borderRadius: "12px" }}
          />
          <Skeleton
            variant="rectangular"
            width={80}
            height={24}
            sx={{ borderRadius: "12px" }}
          />
          <Skeleton
            variant="rectangular"
            width={50}
            height={24}
            sx={{ borderRadius: "12px" }}
          />
        </Box>

        {/* Next session chip */}
        <Skeleton
          variant="rectangular"
          width="100%"
          height={32}
          sx={{ borderRadius: "16px" }}
        />
      </Box>
    </Box>
  );
};

export const SkeletonCards = ({ count = 6 }: { count?: number }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: "8px",
        [theme.breakpoints.up("sm")]: {
          gap: "8px",
        },
        padding: "0 1em",
        maxWidth: "100%",
        width: "100%",
        boxSizing: "border-box",
        overflow: "hidden",
        backgroundColor: theme.colors.peacock50,
      }}
      data-test-id="mobile-search-listing-skeleton-cards"
    >
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonCard key={index} />
      ))}
    </Box>
  );
};
